import { render, staticRenderFns } from "./SaleInfo.vue?vue&type=template&id=568732be"
import script from "./SaleInfo.vue?vue&type=script&lang=js"
export * from "./SaleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports